module.exports = __webpack_public_path__ + "static/img/viral_13.4b4282e0.jpg";